
export enum SelectPropsEnums {
 MODE = 'multiple',
 MAX_TAG_COUNT_RESPONSIVE = 'responsive'
}
